export const HISTORY_EVENT = {
  Initial: 'Initial',
  InitialPublished: 'InitialPublished',
  Edit: 'Edit',
  EditPublished: 'EditPublished',
  Edited: 'Edited',
  Approved: 'Approved',
  Declined: 'Declined',  
  Deactivation: 'Deactivation',
  Deactivated: 'Deactivated',
  Reactivation: 'Reactivation',
  Reactivated: 'Reactivated',
} as const;

export const EVENTS_THAT_NEED_CONFIRMATION: ReadonlyArray<HistoryEventType> = [
  HISTORY_EVENT.Edit,
  HISTORY_EVENT.EditPublished,
  HISTORY_EVENT.Edited,
  HISTORY_EVENT.Initial,
  HISTORY_EVENT.InitialPublished,
  HISTORY_EVENT.Reactivation,
  HISTORY_EVENT.Reactivated,
];

export const EVENT_CONFIRMATION: ReadonlyArray<HistoryEventType> = [
  HISTORY_EVENT.Approved,
  HISTORY_EVENT.Declined,
  HISTORY_EVENT.Deactivated,
  HISTORY_EVENT.Deactivation,
];

